"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
var FileTypeAppspacesIcon_1 = require("./FileTypeAppspacesIcon");
__createBinding(exports, FileTypeAppspacesIcon_1, "FileTypeAppspacesIcon");
var FileTypeDashboardsIcon_1 = require("./FileTypeDashboardsIcon");
__createBinding(exports, FileTypeDashboardsIcon_1, "FileTypeDashboardsIcon");
var FileTypeDataTableIcon_1 = require("./FileTypeDataTableIcon");
__createBinding(exports, FileTypeDataTableIcon_1, "FileTypeDataTableIcon");
var FileTypeFolderIcon_1 = require("./FileTypeFolderIcon");
__createBinding(exports, FileTypeFolderIcon_1, "FileTypeFolderIcon");
var FileTypeFormsIcon_1 = require("./FileTypeFormsIcon");
__createBinding(exports, FileTypeFormsIcon_1, "FileTypeFormsIcon");
var FileTypeMonochromeAppspacesIcon_1 = require("./FileTypeMonochromeAppspacesIcon");
__createBinding(exports, FileTypeMonochromeAppspacesIcon_1, "FileTypeMonochromeAppspacesIcon");
var FileTypeMonochromeDashboardsIcon_1 = require("./FileTypeMonochromeDashboardsIcon");
__createBinding(exports, FileTypeMonochromeDashboardsIcon_1, "FileTypeMonochromeDashboardsIcon");
var FileTypeMonochromeDataTableIcon_1 = require("./FileTypeMonochromeDataTableIcon");
__createBinding(exports, FileTypeMonochromeDataTableIcon_1, "FileTypeMonochromeDataTableIcon");
var FileTypeMonochromeFolderIcon_1 = require("./FileTypeMonochromeFolderIcon");
__createBinding(exports, FileTypeMonochromeFolderIcon_1, "FileTypeMonochromeFolderIcon");
var FileTypeMonochromeFormsIcon_1 = require("./FileTypeMonochromeFormsIcon");
__createBinding(exports, FileTypeMonochromeFormsIcon_1, "FileTypeMonochromeFormsIcon");
var FileTypeMonochromeReportsIcon_1 = require("./FileTypeMonochromeReportsIcon");
__createBinding(exports, FileTypeMonochromeReportsIcon_1, "FileTypeMonochromeReportsIcon");
var FileTypeMonochromeResourceViewIcon_1 = require("./FileTypeMonochromeResourceViewIcon");
__createBinding(exports, FileTypeMonochromeResourceViewIcon_1, "FileTypeMonochromeResourceViewIcon");
var FileTypeMonochromeSheetsIcon_1 = require("./FileTypeMonochromeSheetsIcon");
__createBinding(exports, FileTypeMonochromeSheetsIcon_1, "FileTypeMonochromeSheetsIcon");
var FileTypeMonochromeTemplateIcon_1 = require("./FileTypeMonochromeTemplateIcon");
__createBinding(exports, FileTypeMonochromeTemplateIcon_1, "FileTypeMonochromeTemplateIcon");
var FileTypeMonochromeWorkgroupIcon_1 = require("./FileTypeMonochromeWorkgroupIcon");
__createBinding(exports, FileTypeMonochromeWorkgroupIcon_1, "FileTypeMonochromeWorkgroupIcon");
var FileTypeReportsIcon_1 = require("./FileTypeReportsIcon");
__createBinding(exports, FileTypeReportsIcon_1, "FileTypeReportsIcon");
var FileTypeResourceViewIcon_1 = require("./FileTypeResourceViewIcon");
__createBinding(exports, FileTypeResourceViewIcon_1, "FileTypeResourceViewIcon");
var FileTypeSheetsIcon_1 = require("./FileTypeSheetsIcon");
__createBinding(exports, FileTypeSheetsIcon_1, "FileTypeSheetsIcon");
var FileTypeTemplateIcon_1 = require("./FileTypeTemplateIcon");
__createBinding(exports, FileTypeTemplateIcon_1, "FileTypeTemplateIcon");
var FileTypeWorkgroupIcon_1 = require("./FileTypeWorkgroupIcon");
__createBinding(exports, FileTypeWorkgroupIcon_1, "FileTypeWorkgroupIcon");
//# sourceMappingURL=index.js.map